module.exports = __webpack_public_path__ + "static/media/illustration-fixplay.fb0561e5.svg";